import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import MenusController from "./MenusController";
import ProfileMenuController from "./ProfileMenuController";
import MobileDrawer from "./MobileDrawer";
import { Link, useLocation } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import LogoIcon from "../../../styles/icons/IconFiles/CommonIcons/LogoIcon";
import {
  HandleMenuActiveManual,
  handleCustomerMenuManual,
} from "../../../utils/helpers/helperMethods/HandleMenuActiveManual";
import useUserRole from "../../../hooks/useUserRole";
import { UserRole } from "../../../utils";

const NavigationHeader = () => {
  let location = useLocation();
  const { instance } = useMsal();
  const userRole = useUserRole();

  const [selectedMenu, setSelectedMenu] = React.useState<string>("");
  const [customerSelectedMenu, setCustomerSelectedMenu] =
    React.useState<string>("");

  useEffect(() => {
    setCustomerSelectedMenu(location.pathname.split("/")[2]);
  }, []);

  useEffect(() => {
    HandleMenuActiveManual(location.pathname, setSelectedMenu);
    handleCustomerMenuManual(
      location.pathname.split("/")[2],
      setCustomerSelectedMenu
    );
  }, [location]);

  function handleSelectMenu(name: string) {
    setSelectedMenu(name);
  }

  function handleCustomerSelectMenu(name: string) {
    setCustomerSelectedMenu(name);
  }

  function logoClick() {
    setSelectedMenu("");
    setCustomerSelectedMenu("");
  }
  const activeAccount = instance.getActiveAccount();

  if (
    location.pathname === "/login" ||
    location.pathname === "/signup" ||
    location.pathname === "/forgot-password" ||
    !activeAccount
  ) {
    return null;
  } else {
    return (
      <Container fluid className="navigation-bar">
        <div className="navigation-bar-wrapper">
          <div className="logo-section">
            <Link to="/" onClick={logoClick}>
              <LogoIcon />
            </Link>
          </div>
          <MenusController
            handleSelectMenu={handleSelectMenu}
            handleCustomerSelectMenu={handleCustomerSelectMenu}
            selectedMenu={selectedMenu}
            customerSelectedMenu={customerSelectedMenu}
          />
          <ProfileMenuController />
          <MobileDrawer />
        </div>
      </Container>
    );
  }
};

export default NavigationHeader;
